"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CalendarAction;
(function (CalendarAction) {
    CalendarAction["PICKUP_CALENDAR_UPDATE"] = "pickup_calendar_update";
    CalendarAction["WORKING_DAY_CALENDAR_UPDATE"] = "working_days_calendar_update";
})(CalendarAction = exports.CalendarAction || (exports.CalendarAction = {}));
//# sourceMappingURL=calendar-models.v0.js.map